.band {
  display: flex;
  flex: 0 0 auto;
  flex-direction: column;
  gap: var(--gap);
  min-width: 0;
}

.charts {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(240px, 1fr));
  gap: var(--gap);
}

.charts > * {
  min-width: 0;
}
